import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {

return originalPush.call(this, location).catch(err => err)

}
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/about.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../views/news.vue'),
    },
    {
      path: '/product',
      name: 'procuct',
      component: () => import('../views/product.vue'),
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import('../views/knowledge.vue'),
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js